import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import DoneIcon from '@mui/icons-material/Done';
import { useNavigate } from "react-router-dom";
import { Divider, IconButton, Stack } from "@mui/material";

const style = {
  position: "absolute",
  display:'flex',
  flexDirection:'column',
  alignItems:'center',
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  border: "0px solid #000",
  borderRadius: "0px",
  boxShadow: 24,
  p: 4,
};



export default function EditUserModal({ status, handleCloseModal, toggle }) {
  const navigate = useNavigate();

  return (
    <div>
      <Modal
        keepMounted
        open={(status === "Updated" && toggle)||(status&&toggle)}
        onClose={handleCloseModal}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description">
        <Box sx={style}>



        <IconButton style={{ color: "rgba(0, 201, 32, 1)" }}>
                <DoneIcon sx={{fontSize:'50px'
                }} />
              </IconButton>

              <Stack sx={{ width: "90%" }}>
              <Divider style={{ background: "rgba(223, 223, 223, 1)" }} />
            </Stack>


          {((status === "Updated")||(status)) && (
            <Typography sx={{ mt: 2, color: "black", textAlign: "center" }}>
              Updated Successfully.
            </Typography>
          )}
          {
            <Box
              sx={{
                color: "red",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                marginTop: "10px",
              }}>
              <Button
                variant="contained"
                onClick={() => navigate("/user")}
                sx={{
                  borderRadius: "35px",
                  margin: "auto",
                  textTransform: "none"
                }}
                size="large">
                Got it
              </Button>
            </Box>
          }
        </Box>
      </Modal>
    </div>
  );
}
